import { useSettings } from "@/lib/SettingsContext"
import Link from "next/link"

export function Footer() {
  const { settings } = useSettings()
  return (
    <footer className="border-t bg-gray-50">
      <div className="container px-4 pt-8 pb-4 md:pt-12 *:md:pb-2">
        <div className="grid grid-cols-2 gap-8 md:grid-cols-4">
          <div className="space-y-3">
            <h4 className="text-sm font-medium text-blue-600">Sobre</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <Link href="/about" className="text-gray-600 hover:text-blue-600 transition-colors">
                  Quem somos
                </Link>
              </li>
              <li>
                <Link href="/how-it-works" className="text-gray-600 hover:text-blue-600 transition-colors">
                  Como funciona
                </Link>
              </li>
              <li>
                <Link href="/press" className="text-gray-600 hover:text-blue-600 transition-colors">
                  Imprensa
                </Link>
              </li>
            </ul>
          </div>
          <div className="space-y-3">
            <h4 className="text-sm font-medium text-blue-600">Carona</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <Link href="/search" className="text-gray-600 hover:text-blue-600 transition-colors">
                  Buscar carona
                </Link>
              </li>
              <li>
                <Link href="/offer-seats" className="text-gray-600 hover:text-blue-600 transition-colors">
                  Oferecer carona
                </Link>
              </li>
            </ul>
          </div>
          <div className="space-y-3">
            <h4 className="text-sm font-medium text-blue-600">Ajuda</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <Link href="/help" className="text-gray-600 hover:text-blue-600 transition-colors">
                  Central de ajuda
                </Link>
              </li>
              {(settings.contactFormEnabled || settings.liveChatEnabled || settings.emailContactEnabled || settings.phoneContactEnabled) && (
                <li>
                  <Link href="/help?tab=contact" replace className="text-gray-600 hover:text-blue-600 transition-colors">
                    Contato
                  </Link>
                </li>
              )}
              <li>
                <Link href="/terms" className="text-gray-600 hover:text-blue-600 transition-colors">
                  Termos de uso
                </Link>
              </li>
            </ul>
          </div>
          <div className="space-y-3">
            <h4 className="text-sm font-medium text-blue-600">Legal</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <Link href="/privacy" className="text-gray-600 hover:text-blue-600 transition-colors">
                  Privacidade
                </Link>
              </li>
              <li>
                <Link href="/cookies" className="text-gray-600 hover:text-blue-600 transition-colors">
                  Cookies
                </Link>
              </li>
              <li>
                <Link href="/terms" className="text-gray-600 hover:text-blue-600 transition-colors">
                  Termos e condições
                </Link>
              </li>
            </ul>
          </div>
        </div>
        <div className="mt-8 border-t pt-8 text-center text-sm text-gray-600">
          <p>© 2024 Pediloo. Todos os direitos reservados.</p>
        </div>
      </div>
    </footer>
  )
}

